







import Vue from 'vue'
import roles from '@/services/Roles'

export default Vue.extend({
  name: 'AdminOnly',
  data() {
    return {
      authorized: true,
    }
  },
  async created() {
    this.authorized = await roles.isAdmin()
  },
})
